export default __webpack_public_path__ + "static/media/LinkedIn-Elogiar-Reconhecer-Colega-15.4b964106.jpg";